<template>
  <b-container fluid>
    <b-row align-h="center" class="mt-n5">
      <b-col cols="10" class="mt-5">
        <p
          class="tituto-data mt-5"
        >{{colegio}} {{grado}} {{seccion}}</p>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col lg="12" class="mt-5">
        <Table :data="data" :url="url" />
      </b-col>
    </b-row>

    <b-row align-h="center">
         <img @click="download()" :src="srcImagen('xls.png')" class="results-xls-img" alt />
      <span class="mt-2">
     
        <p
          @click="download()"
          class="results-dowload mt-2 ml-2"
          href
        >DESCARGAR DATA DE TODOS LOS ESTUDIANTES..</p>
      </span>
    </b-row>
    <ModalSend :content="contentMsj" v-if="activeModalSend" />
  </b-container>
</template>
<script>
import Table from "@/components/Global/TableStudent";
import ModalSend from "@/components/Global/ModalSendReturn";
import { mapState } from "vuex";

import XLSX from "xlsx";

export default {
  name: "Data-Estudiante",
  components: {
    Table,
    ModalSend
  },
  data: () => ({
    contentError: {
      title: "Disculpe",
      msj: "La opcion seleccionada no tiene informacion",
      button: "Aceptar",
      icon: 2,
      back: "./"
    },
    contentMsj: {},
    url: "datos-estudiantes",
    colegio:'',
    seccion:'',
    grado:'',
    data: []
  }),
  created() {
    this.$store.dispatch("setNav", 'active');
    this.getDataStudent();

  },
  computed: {
    ...mapState(["activeModal", "activeModalSend"])
  },
  methods: {
    download() {
      /*let obj = this.data.reduce(function(result, item, index) {
  result[index] = item; //a, b, c
  return result;
}, {})*/

      let new_list = this.data.map(function(obj) {
        return {
          nombre: obj.nombre,
          Grado: obj.grado_nombre,
          Seccion: obj.seccion_nombre,
          Correo: obj.correo,
          DNI: obj.dni,
          Carrera: obj.carrera,
          Celular: obj.celular
        };
      });
      console.log([new_list][0]);
      let data = XLSX.utils.json_to_sheet([new_list][0]);
      let workbook = XLSX.utils.book_new();
      let filename = "estudiante";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    goRouter(url) {
      this.$store.dispatch("setNav", "active");
      this.$router.push(url);
    },
    srcImagen(img) {
      let src = require("@/assets/images/" + img);
      return src;
    },
    getDataStudent() {
      this.$store
        .dispatch("GetStudentKey", this.$route.params.id)
        .then(response => {
          this.data = response.data.estudiantes;
          if (this.data.length > 0) {
            this.colegio= this.data[0].colegionombre
          this.seccion= this.data[0].seccion_nombre
            this.grado= this.data[0].grado_nombre


            this.$store.dispatch("setActiveModalSend", false);
          } else {
            this.contentMsj = this.contentError;
            this.$store.dispatch("setActiveModalSend", true);
          }
        })
        .catch(error => {
          console.log(error.message);
        });
    }
  }
};
</script>